export const QueryKey = {
    Scenarios: 'Scenarios',
    Tenant: 'Tenant',
    Reports: 'Reports',
    ApiKeys: 'ApiKeys',
    GoogleSettings: 'GoogleSettings',
    History: 'History',
    Interactions: 'Interactions',
    Users: 'Users',
    VideoDetail: 'VideoDetail',
};
